@for (slug of slugs; track slug) {
<div class="document-row d-flex align-items-center justify-content-between"
    [attr.data-testid]="'agency-document-' + slug">
    <div>
        <div>{{ labels[slug] }}</div>
        <small class="text-muted">{{ documents[slug]?.originalFilename || 'Non fourni' }}</small>
    </div>
    <div class="d-flex align-items-center">
        @if (documents[slug]) {
        <button mat-icon-button type="button" (click)="preview(slug)" matTooltip="Voir"
            aria-label="Voir le document" [attr.data-testid]="'agency-document-preview-' + slug">
            <mat-icon>visibility</mat-icon>
        </button>
        <button mat-icon-button type="button" (click)="download(slug)" matTooltip="Télécharger"
            aria-label="Télécharger le document">
            <mat-icon>download</mat-icon>
        </button>
        }
        <input #fileInput type="file" hidden [accept]="accept[slug].join(',')"
            (change)="upload(slug, fileInput)" [attr.data-testid]="'agency-document-input-' + slug" />
        <button mat-icon-button type="button" (click)="fileInput.click()" [disabled]="!!busySlug || !agencyId"
            [matTooltip]="documents[slug] ? 'Remplacer' : 'Ajouter'"
            [attr.aria-label]="documents[slug] ? 'Remplacer le document' : 'Ajouter le document'"
            [attr.data-testid]="'agency-document-upload-' + slug">
            <mat-icon>{{ documents[slug] ? 'sync' : 'upload' }}</mat-icon>
        </button>
        @if (documents[slug]) {
        <button mat-icon-button type="button" color="warn" (click)="remove(slug)" [disabled]="!!busySlug"
            matTooltip="Supprimer" aria-label="Supprimer le document"
            [attr.data-testid]="'agency-document-delete-' + slug">
            <mat-icon>delete</mat-icon>
        </button>
        }
    </div>
</div>
}
